// extracted by mini-css-extract-plugin
export default {"large":"Psecond_large__nC4-5","little":"Psecond_little__tHkjJ","normal":"Psecond_normal__l-sVT","Psecond":"Psecond_Psecond__-OLgT","text":"Psecond_text__o6zAx"};